import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { CardElement as CardElementStripe } from '@stripe/react-stripe-js';

import { CardElement as CardElementSolidgate } from '../../solidgate';
import { CardElement as CardElementPaddle } from '../../paddle';
import { CardElement as CardElementTruegate } from '../../truegate';

import { PaymentSystem } from '../../constants';
import { getPublicKeys } from '../../utils/storage';

import { CardElement as CardElementRecurly } from './recurly';
import getLocale from '@web-solutions/core/localization/get-locale';

const CardElement = React.forwardRef(
  (
    {
      paymentSystem,
      product,
      options,
      className,
      onSubmit,
      onChange,
      onReady,
      onSuccess,
      onError,
      onApplePayClick,
      onApplePaySubmit,
      onGooglePayClick,
      onGooglePaySubmit,
      onUserInfoChange,
      onEvent,
      inputStyles,
      labelStyles,
      notEmptyLabelStyles,
      paymentPopup,
      buttonTitle,
      subscriptionPageType
    },
    ref
  ) => {
    const publicKeys = getPublicKeys();

    const handleSubmit = useCallback(
      (formData) => {
        formData.method = 'card';
        onSubmit(formData);
      },
      [onSubmit]
    );

    switch (paymentSystem) {
      case PaymentSystem.RECURLY:
        return (
          <CardElementRecurly
            ref={ref}
            product={product}
            options={options}
            className={className}
            onSubmit={handleSubmit}
            onChange={onChange}
            onReady={onReady}
            paymentPopup={paymentPopup}
          />
        );
      case PaymentSystem.STRIPE:
        return (
          <CardElementStripe
            ref={ref}
            product={product}
            options={options}
            className={className}
            onSubmit={handleSubmit}
            onChange={onChange}
            onReady={onReady}
          />
        );
      case PaymentSystem.SOLIDGATE:
        return (
          <CardElementSolidgate
            ref={ref}
            product={product}
            options={options}
            className={className}
            onChange={onChange}
            onReady={onReady}
            onSubmit={handleSubmit}
            onSuccess={onSuccess}
            onError={onError}
            onApplePayClick={onApplePayClick}
            onApplePaySubmit={onApplePaySubmit}
            onGooglePayClick={onGooglePayClick}
            onGooglePaySubmit={onGooglePaySubmit}
            onUserInfoChange={onUserInfoChange}
            inputStyles={inputStyles}
            labelStyles={labelStyles}
            notEmptyLabelStyles={notEmptyLabelStyles}
          />
        );
      case PaymentSystem.PADDLE:
        return (
          <CardElementPaddle
            ref={ref}
            config={publicKeys?.paddle}
            product={product}
            options={options}
            className={className}
            onChange={onChange}
            onReady={onReady}
            onSuccess={onSuccess}
            onError={onError}
            onUserInfoChange={onUserInfoChange}
            onEvent={onEvent}
          />
        );
        case PaymentSystem.TRUEGATE:
          return (
            <CardElementTruegate
              isDarkMode={false}
              options={options}
              product={product}
              onReady={onReady}
              buttonTitle={buttonTitle}
              onSubmit={handleSubmit}
              onUserInfoChange={onUserInfoChange}
              onSuccess={onSuccess}
              onError={onError}
            />
          );
    }
    return null;
  }
);

CardElement.propTypes = {
  onSubmit: PropTypes.func,
  onChange: PropTypes.func,
  onReady: PropTypes.func,
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
  onApplePayClick: PropTypes.func,
  onApplePaySubmit: PropTypes.func,
  onGooglePayClick: PropTypes.func,
  onGooglePaySubmit: PropTypes.func,
  onUserInfoChange: PropTypes.func,
  onEvent: PropTypes.func,
  className: PropTypes.string,
  options: PropTypes.object,
};

export default CardElement;
